// delete this file when removing the FF isMigrateArjTeamsToPlatformTeamsEnabled

import { SET_TWP_BENEFITS_MODAL_OPEN, type ShowTwpBenefitsModalAction, type State } from './types';

const initialState: State = {
	isTwpBenefitsModalOpen: false,
};

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default (state: State = initialState, action: ShowTwpBenefitsModalAction) => {
	switch (action.type) {
		case SET_TWP_BENEFITS_MODAL_OPEN:
			return {
				...state,
				isTwpBenefitsModalOpen: action.payload,
			};
		default: {
			const _exhaustiveCheck: never = action.type;
			return state;
		}
	}
};
